import React, { useContext, useRef } from 'react';
import { HeaderContext } from '@contexts/HeaderContext';
import LanguageContainer from '../common/LanguageContainer';
import PlatformContainer from '../common/PlatformContainer';
import SocialContainer from '../common/SocialContainer';
import useOnClickOutside from '../../hooks/useOnClickOutSide';

const RightNav = ({
    siteName, closeButtonRef, children, liveChat,
}) => {
    const [{ isShowRightNav }, dispatch] = useContext(HeaderContext);
    const rightNavMainRef = useRef(null);
    const platformContainerRef = useRef(null);
    const isTriggerTouchStart = false;

    const handleTouchMove = () => {
        if (platformContainerRef?.current) {
            const {
                top:
                distanceFromViewPortTop,
            } = platformContainerRef.current?.getBoundingClientRect() || {};
            if (distanceFromViewPortTop < (42 - 25)) {
                dispatch({ type: 'SET_IS_CLOSE_BUTTON_VISIBLE', value: false });
            } else {
                dispatch({ type: 'SET_IS_CLOSE_BUTTON_VISIBLE', value: true });
            }
        }
    };

    const scrollToTop = () => {
        if (rightNavMainRef?.current) {
            rightNavMainRef.current?.scrollTo({
                top: 0,
                behavior: 'instant',
            });
        }
    };

    useOnClickOutside([rightNavMainRef, closeButtonRef], () => {
        dispatch({ type: 'TOGGLE_RIGHT_NAV_SHOWING', value: false });
        scrollToTop();
        dispatch({ type: 'SET_IS_CLOSE_BUTTON_VISIBLE', value: true });
    }, isTriggerTouchStart);

    return (
        <div
            className="side-nav"
            data-open={isShowRightNav}
            role="mobile-visible"
        >
            {children}
            <div className="side-nav__main" ref={rightNavMainRef} onScroll={handleTouchMove}>
                <PlatformContainer layoutType="rightNav" ref={platformContainerRef} />
                {liveChat === true && 
                    <SocialContainer layoutType="rightNav" siteName={siteName}  />
                }
                <LanguageContainer layoutType="rightNav" />
            </div>
        </div>
    );
};
export default RightNav;
